import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReadOnlySlashIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.543 4.49561L15.75 6.28857V14.4185C13.14 14.4185 10.77 15.439 9 17.0815C8.29102 16.4206 7.48483 15.8636 6.60645 15.4314L4.81494 17.2236L3.75439 16.1631L16.4824 3.43506L17.543 4.49561ZM14.231 7.80688L7.72266 14.3152C8.16456 14.5578 8.5916 14.8298 9 15.1311C10.5525 13.9911 12.3525 13.2716 14.25 13.0166V7.80396C14.2437 7.8051 14.2373 7.80568 14.231 7.80688Z"
    />
    <path d="M2.25 6.16846C4.81811 6.16846 7.15239 7.15062 8.91284 8.75391L7.85815 9.80859C6.6884 8.76089 5.272 8.07131 3.75 7.7959V13.0085C4.01044 13.0435 4.26903 13.0885 4.52563 13.1411L3.20288 14.4639C2.88935 14.4338 2.57148 14.4185 2.25 14.4185V6.16846Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0.918457C10.6574 0.918457 11.9998 2.26109 12 3.91846C12 5.57596 10.6575 6.91846 9 6.91846C7.3425 6.91846 6 5.57596 6 3.91846C6.00016 2.26109 7.3426 0.918457 9 0.918457ZM9 2.41846C8.1751 2.41846 7.50016 3.09359 7.5 3.91846C7.5 4.74346 8.175 5.41846 9 5.41846C9.825 5.41846 10.5 4.74346 10.5 3.91846C10.4998 3.09359 9.8249 2.41846 9 2.41846Z"
    />
  </Icon>
);

export default memo(ReadOnlySlashIcon);
